module.exports = __webpack_public_path__ + "asxdata.png?7d88bf3e06b747b4f1dca5e724562e4e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/asxdata.png
// module id = 225
// module chunks = 0